import axios from 'axios'

import { ERROR_MESSAGE_DOWNLOADING_FILE } from '../constants'
import { handleRequestError } from './request'

export const DOWNLOAD_MESSAGE_ATTACHMENT = 'DOWNLOAD_MESSAGE_ATTACHMENT'
export const RECEIVE_MESSAGES = 'RECEIVE_MESSAGES'
export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE'
export const REQUEST_MESSAGES = 'REQUEST_MESSAGES'
export const SEND_MESSAGE = 'SEND_MESSAGE'
export const RECEIVE_DRAFT_MESSAGE_FILES = 'RECEIVE_MESSAGE_DRAFT_FILES'

export const requestMessages = () => (dispatch) => {
    dispatch({ type: REQUEST_MESSAGES })

    return axios
        .get('/messages')
        .then((response) => {
            const items = response?.data || []
            dispatch(receiveMessages({ items, fetchSuccessful: true }))
        })
        .catch((error) => {
            dispatch(receiveMessages({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveMessages = (data) => ({ type: RECEIVE_MESSAGES, data })

export const receiveMessage = (data) => ({ type: RECEIVE_MESSAGE, data })

export const sendMessage = (formData) => (dispatch) => {
    dispatch({ type: SEND_MESSAGE })

    return axios
        .post('/messages', formData)
        .then((response) => {
            const message = response?.data || {}

            dispatch(receiveMessage(message))

            return Promise.resolve(message)
        })
        .catch((error) => {
            dispatch(handleRequestError(error))
            return Promise.reject(error)
        })
}

export const downloadMessageAttachment =
    ({ fileId }) =>
    (dispatch) => {
        axios
            .get(`/emailattachments/${fileId}/downloadlink`)
            .then((response) => {
                if (response.data) {
                    window.location.assign(response.data)
                }
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DOWNLOADING_FILE }))
            })
    }

export const receiveDraftMessageFiles = (data) => ({ type: RECEIVE_DRAFT_MESSAGE_FILES, data })
